import { REQUIRED_MESSAGE, requiredString } from '@wyz/utils';
import { z } from 'zod';
import { associatedCriteriaSchema, externalIdSchema } from '~/common/schemas';

export const redistributionBrandSchema = z.object({
  publicKey: z.string(),
  name: z.string(),
  segment: z.object({ publicKey: z.string() }),
});

export const redistributionBrandTemplateSchema = z.object({
  id: z.string(),
  default: z.boolean(),
  name: requiredString,
  criteria: z.array(associatedCriteriaSchema),
  brands: z
    .array(
      z.object({
        externalId: externalIdSchema,
      }),
    )
    .min(1, REQUIRED_MESSAGE),
  customerScope: z
    .array(
      z.object({
        id: z.string({
          error: (issue) =>
            issue.input === undefined ? REQUIRED_MESSAGE : undefined,
        }),
      }),
    )
    .min(1, REQUIRED_MESSAGE),
});

export const redistributionBrandTemplateFormSchema =
  redistributionBrandTemplateSchema
    .omit({
      id: true,
      criteria: true,
      brands: true,
      customerScope: true,
    })
    .extend({
      criteria: z
        .array(
          z.object({
            criterion: z.object({ id: z.string() }),
            values: z.array(requiredString).min(1, {
              error: REQUIRED_MESSAGE,
            }),
          }),
        )
        .min(1, {
          error: REQUIRED_MESSAGE,
        }),
      brands: z.array(redistributionBrandSchema).min(1, REQUIRED_MESSAGE),
      customerScope: z.array(z.string()).min(1, REQUIRED_MESSAGE),
    });

export const redistributionBrandTemplatePayloadSchema =
  redistributionBrandTemplateSchema.omit({
    id: true,
  });
